// extracted by mini-css-extract-plugin
export var container = "SearchBar-module--container--13f16";
export var field = "SearchBar-module--field--56c26";
export var hasFocus = "SearchBar-module--hasFocus--64309";
export var icon = "SearchBar-module--icon--3159c";
export var isBreakout = "SearchBar-module--isBreakout--25177";